<template>
<intersect @enter="comeIn()">
  <div class="demo-widget">
    <div class="interactive-widget">
      <div class="graph-wrapper">
        <div class="graph">
          <div class="active-graph">
            <div class="background">

            </div>
            <div class="finish-line">
            </div>
            <div class="v-tick">
            </div>
            <div class="v-tick">
            </div>
            <div class="v-tick">
            </div>
            <div class="v-tick">
            </div>
            <div class="v-tick ie">
            </div>
            <div class="trace">
            </div>
            <div id="sparkline" class="render">

            </div>
            <div class="arrow-up arrow">
            </div>
            <div class="arrow-down arrow">
            </div>
            <img src="@/assets/images/high-win.png" class="bet high win" />
            <img src="@/assets/images/high-lose.png" class="bet high lose" />
            <img src="@/assets/images/low-win.png" class="bet low win" />
            <img src="@/assets/images/low-lose.png" class="bet low lose" />
          </div>
        </div>
        <div class="currency">
          {{$t("home.demo.new.widget.currency")}}
        </div>
      </div>
      <span class="button-wrapper high">
        <div class="button high">
          {{$t("home.demo.new.widget.high")}}
          <div class="bottom">
          </div>
          <div class="corner">
          </div>
        </div>
      </span>
      <span class="button-wrapper low">
        <div class="button low">
          {{$t("home.demo.new.widget.low")}}
          <div class="bottom">
          </div>
          <div class="corner">
          </div>
        </div>
      </span>
      <div class="reset-button try-again" @click="reset()">
        <span class="word">
          {{$t("home.demo.new.widget.reset")}}
        </span>
      </div>
      <div class="floating-tip">
        <div class="tip">
          <div class="content">
            <div class="triangle-up"></div>
            <span class="word message">{{$t("home.demo.new.widget.try-it")}}</span>
          </div>
        </div>
      </div>
      <div class="timeline-wrapper">
        <div class="timeline">
          <div class="tick">
            12:10
          </div>
          <div class="tick">
            12:15
          </div>
          <div class="tick">
            12:20
          </div>
          <div class="tick">
            12:25
          </div>
          <div class="tick">
            12:30
          </div>
          <div class="tick">
            <span class="highlight">
              12:35
              <div class="triangle-up"></div>
            </span>
          </div>
        </div>
      </div>

      <!--<div class="bait">
        <a href="#" v-html="$t('home.demo.new.quick-demo')"> </a>
      </div>-->
    </div>
  </div>
</intersect>
</template>

<script>
  /* eslint-disable no-undef */
  /* eslint-disable no-redeclare */
  var $ = require("jquery")
  import utils from '@/jquery/utils'
  // Sparkline
  import '@/jquery/jquery.sparkline'
  import Intersect from 'vue-intersect'

  export default {
    components: { Intersect },
    data () {
      return {
        initValues: ["27", "12:27", "16:31", "28:32", "33:37", "38:32", "48:32", "52:35", "82:35", "87:37",
            "110:37", "118:41", "125:41", "131:42", "138:39", "144:39", "146:50", "156:50", "160:48", "168:48", "173:75",
            "183:70", "190:86", "196:82", "204:82", "210:77", "214:66", "221:70", "235:70", "239:73", "243:70", "257:76",
            "262:85", "264:83", "270:88", "277:85", "286:85", "288:88", "296:88", "300:106", "308:102", "315:105", "321:102",
            "327:104", "333:101", "346:101", "349:113", "352:110", "362:110", "367:107", "379:107", "382:103", "390:108",
            "398:108", "402:111", "406:113"
          ],
        resetValues: ["27", "12:27", "16:31", "28:32", "33:37", "38:32", "48:32", "52:35", "82:35", "87:37",
            "110:37", "118:41", "125:41", "131:42", "138:39", "144:39", "146:50", "156:50", "160:48", "168:48", "173:75",
            "183:70", "190:86", "196:82", "204:82", "210:77", "214:66", "221:70", "235:70", "239:73", "243:70", "257:76",
            "262:85", "264:83", "270:88", "277:85", "286:85", "288:88", "296:88", "300:106", "308:102", "315:105", "321:102",
            "327:104", "333:101", "346:101", "349:113", "352:110", "362:110", "367:107", "379:107", "382:103", "390:108",
            "398:108", "402:111", "406:113"
          ],
        initOptions: {
            type: "line",
            width: "516",
            height: "226",
            lineColor: "#ff9b00",
            fillColor: "#fec300",
            lineWidth: 3,
            spotColor: "#fff",
            minSpotColor: !1,
            maxSpotColor: !1,
            spotRadius: 6,
            chartRangeMin: 0,
            chartRangeMax: 226,
            chartRangeMinX: 0,
            chartRangeMaxX: 518,
            disableTooltips: !0,
            disableHighlight: !0,
            drawNormalOnTop: !1
          },
          
        winRate: .8, 
        biasFactor: .58, 
        lastSix: []
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    },
    methods: {
      init() {
        var a = this;
        a.setup(), $(".demo-widget").length > 0 && ($("#sparkline").sparkline(a.initValues, a.initOptions), $(
          ".demo-widget").on("click", ".button.high", function () {
          a.pick(1)
        }), $(".demo-widget").on("click", ".button.low", function () {
          a.pick(-1)
        }), $(".demo-widget").on("click", ".try-again", function () {
          a.running || !a.finished || a.reset()
        }))
      },
      setup() {
        var a = this;
        a.started = !1, a.widget = $(".demo-widget .interactive-widget"), a.graphContainer = $(".demo-widget .render"), a
          .easing = [.76, 0, .29, 1], a.chartEasing = [.35, .08, .16, .96], a.arrowUp = $(".demo-widget .arrow.arrow-up"),
          a.arrowDown = $(".demo-widget .arrow.arrow-down"), a.tip = $(".demo-widget .floating-tip .tip"), a
          .tipMessageDisplay = $(".demo-widget .floating-tip .content .message"), a.traceLine = $(".demo-widget .trace"),
          a.hWin = $(".demo-widget .bet.high.win"), a.lWin = $(".demo-widget .bet.low.win"), a.hLose = $(
            ".demo-widget .bet.high.lose"), a.lLose = $(".demo-widget .bet.low.lose"), a.bet = $(".demo-widget .bet"), a
          .hBetTop = 83, a.lBetTop = 120, a.hWin.css({
            display: "none"
          }), a.lWin.css({
            display: "none"
          }), a.hLose.css({
            display: "none"
          }), a.lLose.css({
            display: "none"
          }), a.widget.css({
            opacity: 0,
            top: "60px"
          }), a.graphContainer.css({
            width: 0
          }), a.arrowUp.css({
            opacity: 0,
            top: "86px",
            right: "59px"
          }), a.arrowDown.css({
            opacity: 0,
            top: "113px",
            right: "59px"
          }), a.tip.css({
            opacity: 0,
            top: "-20px"
          }), a.traceLine.css({
            opacity: 0,
            left: "400px",
            width: 0
          });
        var b = "Try it out!";
      },
      reset(a) {
        var b = this;
        b.initValues = b.resetValues.slice(), b.initOptions.spotRadius = 6, b.hWin.velocity({
          top: b.hBetTop - 3 + "px"
        },
        {
          duration: 500,
          easing: b.easing,
          complete: function () {
            b.hWin.css({
              display: "none"
            })
          }
        }), b.lWin.velocity({
          top: b.lBetTop + 3 + "px"
        },
        {
          duration: 500,
          easing: b.easing,
          complete: function () {
            b.lWin.css({
              display: "none"
            })
          }
        }), b.hLose.velocity({
          top: b.hBetTop - 3 + "px"
        },
        {
          duration: 500,
          easing: b.easing,
          complete: function () {
            b.hLose.css({
              display: "none"
            })
          }
        }), b.lLose.velocity({
          top: b.lBetTop + 3 + "px"
        },
        {
          duration: 500,
          easing: b.easing,
          complete: function () {
            b.lLose.css({
              display: "none"
            })
          }
        }), b.arrowUp.css({
          top: "86px",
          right: "59px"
        }), b.arrowDown.css({
          top: "113px",
          right: "59px"
        }), b.traceLine.velocity({
          opacity: 0,
          left: "-8px",
          width: "0px"
        },
        {
          duration: 300,
          easing: b.easing
        }), b.started = !1;
        var c = "Try it out!";
        this.updateMessage(c), b.graphContainer.velocity({
          width: 0
        },
        {
          duration: 650,
          easing: b.easing,
          complete: function () {
            $("#sparkline").sparkline(b.initValues, b.initOptions), b.comeBackIn(a)
          }
        })
      },
      updateMessage(a) {
        var b = this;
        b.tipMessageDisplay.html(a)
      },
      comeBackIn(a) {
        var b = this;
        b.widget.velocity({
          opacity: 1,
          top: "2px"
        },
        {
          duration: 500,
          easing: b.easing,
          complete: function () {
            b.graphContainer.velocity({
              width: "416px"
            },
            {
              duration: 500,
              easing: b.chartEasing
            }), setTimeout(function () {
              b.traceLine.velocity({
                opacity: 1,
                left: "-8px",
                width: "496px"
              },
              {
                duration: 450,
                easing: b.easing
              }), b.arrowUp.velocity({
                width: "34px",
                top: "76px",
                opacity: 1,
                right: "39px"
              },
              {
                duration: 600,
                easing: b.easing
              }), b.arrowDown.velocity({
                width: "34px",
                top: "123px",
                opacity: 1,
                right: "39px"
              },
              {
                duration: 600,
                easing: b.easing,
                complete: function () {
                  setTimeout(this.flashSpot, 125)
                }
              }), b.showFloatTip(), setTimeout(a, 250)
            },
            450)
          }
        })
      },
      comeIn() {
        var a = this;
        a.came = !0, a.widget.velocity({
          opacity: 1,
          top: "2px"
        },
        {
          duration: 700,
          easing: a.easing,
          complete: function () {
            a.graphContainer.velocity({
              width: "416px"
            },
            {
              duration: 1e3,
              easing: a.chartEasing
            }), setTimeout(function () {
              a.traceLine.velocity({
                opacity: 1,
                left: "-8px",
                width: "496px"
              },
              {
                duration: 750,
                easing: a.easing
              }), a.arrowUp.velocity({
                width: "34px",
                top: "76px",
                opacity: 1,
                right: "39px"
              },
              {
                duration: 800,
                easing: a.easing
              }), a.arrowDown.velocity({
                width: "34px",
                top: "123px",
                opacity: 1,
                right: "39px"
              },
              {
                duration: 800,
                easing: a.easing,
                complete: function () {
                  setTimeout(this.flashSpot, 125), a.prepared = !0
                }
              }), a.showFloatTip()
            },
            800)
          }
        })
      },
      pick(a) {
        var b = this;
        if (b.started || !b.prepared) b.finished && b.reset(function () {
          b.pick(a)
        });
        else {
          b.running = !0, b.started = !0, b.finished = !1, b.arrowUp.velocity({
            top: "56px",
            opacity: 0,
            right: "19px"
          },
          {
            duration: 500,
            easing: b.easing
          }), b.arrowDown.velocity({
            top: "123px",
            opacity: 0,
            right: "19px"
          },
          {
            duration: 500,
            easing: b.easing
          }), b.dockTip(), b.betDirection = a;
          for (var c = Math.random() < b.winRate, d = 0, e = 0, f = 0; f < 6; f++) f < 2 && (d += this.lastSix[f]),
            e += this.lastSix[f];
          c ? g += .025 : g -= .025;
          var g = b.biasFactor;
          d < 0 && (c = 1, g = .75), e > 5 && (c = 0, g = .45), setTimeout(function () {
            a > 0 ? $(".bet.high.win").css({
              display: "block",
              top: "73px"
            }).velocity({
              top: "83px"
            },
            {
              duration: 500,
              easing: b.easing,
              complete: function () {
                b.simulate(c ? 1 - g : g)
              }
            }) : $(".bet.low.win").css({
              display: "block",
              top: "130px"
            }).velocity({
              top: "120px"
            },
            {
              duration: 500,
              easing: b.easing,
              complete: function () {
                b.simulate(c ? g : 1 - g)
              }
            })
          },
          400)
        }
      },
      simulate(a) {
        var b = this;
        b.stopFlashingSpot = !0;
        var minInterval = 150, maxInterval = 250, minDisplacement = 2, maxDisplacement = 7, finalX = 489;
        b.graphContainer.css({
            width: "512px"
          });
        var c = function () {
          var d = b.initValues[b.initValues.length - 1].split(":"),
            e = d[0],
            f = d[1],
            g = utils.getRandomInt(minDisplacement, maxDisplacement);
          
          var newY = Math.random() > a ? parseInt(f) + g : parseInt(f) - g;
          var h = parseInt(e) + 5;
          h >= finalX && (h = finalX), b.initValues.push(h + ":" + newY), b.initOptions.spotRadius = 6, $(
            "#sparkline").sparkline(b.initValues, b.initOptions), h < finalX ? setTimeout(c, utils
            .getRandomInt(minInterval, maxInterval)) : b.showResult()
        };
        c()
      },
      showResult() {
        var a = this,
          b = a.initValues[a.initValues.length - 1].split(":"),
          c = (b[0], b[1]),
          d = 200;
        if (c < 113 && a.betDirection < 0 || c > 113 && a.betDirection > 0) {
          this.lastSix.unshift(1), this.lastSix.length > 6 && this.lastSix.pop(), a.betDirection < 0 ? a
            .lWin.velocity({
              top: "123px"
            },
            {
              duration: d,
              easing: a.easing,
              complete: function () {
                a.lWin.velocity({
                  top: "120px"
                },
                {
                  duration: d,
                  easing: a.easing,
                  complete: function () {
                    a.lWin.velocity({
                      top: "123px"
                    },
                    {
                      duration: d,
                      easing: a.easing,
                      complete: function () {
                        a.lWin.velocity({
                          top: "120px"
                        },
                        {
                          duration: d,
                          easing: a.easing,
                          complete: function () {
                            a.running = !1, a.finished = !0
                          }
                        })
                      }
                    })
                  }
                })
              }
            }) : a.hWin.velocity({
              top: "80px"
            },
            {
              duration: d,
              easing: a.easing,
              complete: function () {
                a.hWin.velocity({
                  top: "83px"
                },
                {
                  duration: d,
                  easing: a.easing,
                  complete: function () {
                    a.hWin.velocity({
                      top: "80px"
                    },
                    {
                      duration: d,
                      easing: a.easing,
                      complete: function () {
                        a.hWin.velocity({
                          top: "83px"
                        },
                        {
                          duration: d,
                          easing: a.easing,
                          complete: function () {
                            a.running = !1, a.finished = !0
                          }
                        })
                      }
                    })
                  }
                })
              }
            });
          var e = `${this.$t("home.demo.new.widget.win")} <span class='try-again'>${this.$t("home.demo.new.widget.try-again")}</span>`;
          a.updateMessage(e)
        } else {
          this.lastSix.unshift(-1), this.lastSix.length > 6 && this.lastSix.pop(), a.betDirection < 0 ?
            (a.lWin.css({
              display: "none"
            }), a.lLose.css({
              display: "block"
            })) : (a.hWin.css({
              display: "none"
            }), a.hLose.css({
              display: "block"
            })), a.running = !1, a.finished = !0;
          var e = `${this.$t("home.demo.new.widget.lose")} <span class='try-again'>${this.$t("home.demo.new.widget.try-again")}</span>`;
          a.updateMessage(e)
        }
      },
      showFloatTip() {
        var a = this;
        setTimeout(function () {
          a.tip.velocity({
            opacity: 1,
            top: "8px"
          },
          {
            duration: 600,
            complete: function () {
              a.floatTip()
            }
          })
        },
        250)
      },
      dockTip() {
        var a = this;
        a.tip.velocity("stop"), a.tip.velocity({
          top: "0"
        }), clearTimeout(this.floatTip)
      },
      floatTip() {
        var a = this,
          b = [.48, 0, .36, 1];
        a.tip.velocity({
          top: "-8px"
        },
        {
          duration: 1e3,
          easing: b,
          complete: function () {
            a.tip.velocity({
              top: "8px"
            },
            {
              duration: 1e3,
              easing: b,
              complete: function () {
                setTimeout(this.floatTip)
              }
            })
          }
        })
      },
      flashSpot() {
        this.stopFlashingSpot ? (this.initOptions.spotRadius = 6, $("#sparkline").sparkline(this
          .initValues, this.initOptions)) : (this.initOptions.spotRadius = 7, $("#sparkline").sparkline(
          this.initValues, this.initOptions), setTimeout(function () {
          this.initOptions.spotRadius = 6, $("#sparkline").sparkline(this.initValues, this
            .initOptions), setTimeout(this.flashSpot, 550)
        },
        550))
      }

    }
  }
</script>